import { CircularProgress } from '@material-ui/core';
import axios from 'api/axios';
import BriefInfo from 'components/User/BriefInfo';
import useTitle from 'hooks/useTitle';
import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useFreight } from 'useStores/useFreight';
import EditForm from './EditForm';
import EditActions from './EditAction';
import TwoCards from 'components/Card/TwoCards';

const EditFreightOrder = () => {
  useTitle('ویرایش سفارش باربری');
  const { orderId } = useParams();
  const setTitle = useFreight((state) => state.setTitle);
  const setCategory = useFreight((state) => state.setCategory);
  const location = useLocation();
  const [data, setData] = useState(null);
  const [loadingFetch, setLoadingFetch] = useState(false);
  const setEditedOrderForm = useFreight((state) => state.setEditedOrderForm);

  const fetchOrder = async () => {
    try {
      setLoadingFetch(true);
      const { data } = await axios.get(`/api/v1/freight/order/${orderId}`);
      setData(data);
      Object.entries(data).forEach(([key, value]) => {
        if (key === 'fleetOptions') {
          return setEditedOrderForm(value, 'fleetType');
        }
        return setEditedOrderForm(value, key);
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFetch(false);
    }
  };

  React.useEffect(() => {
    setTitle('ویرایش سفارش');
    setCategory('درهنگام ویرایش دقت کنید. نتایج غیرقابل پیش بینی خواهند بود');
  }, [location.pathname]);

  useEffect(() => {
    fetchOrder();
  }, []);

  return data ? (
    <TwoCards
      title=""
      category=""
      secondaryTitle="مدیریت سفارش"
      secondaryCategory="جهت مدیریت سفارش"
      secondaryContent={
        <EditActions
          refresh={fetchOrder}
          data={data}
          freightId={location.state}
        />
      }
      breadcrumbs={false}
    >
      <>
        <BriefInfo user={data?.freight} />
        <EditForm />
      </>
    </TwoCards>
  ) : (
    <div>
      <CircularProgress />
    </div>
  );
};

export default EditFreightOrder;
